import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_REPORTS_ROUTE } from "../../../../../constants/routes"
import { PosTransactionsTable, ProductionOrderTypeFilter } from "./PosTransactionsTable"

export function Transactions() {
    return (
        <>
            <LocalizedStrict id="production-transactions-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.PRODUCTION_TRANSACTIONS} title="Transactions">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-production">
                            <Breadcrumb>Production</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="production-transactions-breadcrumb">
                            <Breadcrumb>Transactions</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <PosTransactionsTable showStatusColumn={false} defaultOrderType={ProductionOrderTypeFilter.LUNCH} />
        </>
    )
}
